import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'chinh-sach-bao-mat-thong-tin',
    loadComponent: () => import('./pages/chinh-sach-bao-mat-thong-tin/chinh-sach-bao-mat-thong-tin.component').then(m => m.ChinhSachBaoMatThongTinComponent)
  },
  {
    path: 'tra-cuu-chung-thu',
    loadComponent: () => import('./pages/tra-cuu-chung-thu/tra-cuu-chung-thu.component').then(m => m.TraCuuChungThuComponent)
  },
  {
    path: 'tra-cuu-nhan-vien',
    loadComponent: () => import('./pages/tra-cuu-nhan-vien/tra-cuu-nhan-vien.component').then(m => m.TraCuuNhanVienComponent)
  },
  {
    path: 'ho-so-phan-cong',
    loadComponent: () => import('./pages/ho-so-phan-cong/ho-so-phan-cong.component').then(m => m.HoSoPhanCongComponent),
    canActivate: [authGuard]
  },
  {
    path: 'list',
    loadComponent: () => import('./pages/list/list.component').then(m => m.ListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quantitative-apartment',
    loadComponent: () => import('./pages/quantitative-apartment/quantitative-apartment.component').then(m => m.QuantitativeApartmentComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quantitative-different',
    loadComponent: () => import('./pages/quantitative-different/quantitative-different.component').then(m => m.QuantitativeDifferentComponent),
    canActivate: [authGuard]
  },
  {
    path: 'process-valuation',
    loadComponent: () => import('./pages/process-valuation/process-valuation.component').then(m => m.ProcessValuationComponent),
    canActivate: [authGuard]
  },
  {
    path: 'test-ag',
    loadComponent: () => import('./pages/test-ag/test-ag.component').then(m => m.TestAgComponent),
    canActivate: [authGuard]
  },
  {
    path: 'yeu-cau-tham-dinh',
    loadComponent: () => import('./pages/yeu-cau-tham-dinh/yeu-cau-tham-dinh.component').then(m => m.YeuCauThamDinhComponent),
    canActivate: [authGuard]
  },
  {
    path: 'yeu-cau-tham-dinh-gia',
    loadComponent: () => import('./pages/yeu-cau-tham-dinh-gia/yeu-cau-tham-dinh-gia.component').then(m => m.YeuCauThamDinhGiaComponent),
    canActivate: [authGuard]
  },
  {
    path: 'list-form-customer',
    loadComponent: () => import('./pages/list-form-customer/list-form-customer.component').then(m => m.ListFormCustomerComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quy-trinh-tham-dinh',
    loadComponent: () => import('./pages/quy-trinh-tham-dinh/quy-trinh-tham-dinh.component').then(m => m.QuyTrinhThamDinhComponent),
    canActivate: [authGuard]
  },
  {
    path: 'danh-sach-user-tin-dung',
    loadComponent: () => import('./pages/danh-sach-user-tin-dung/danh-sach-user-tin-dung.component').then(m => m.DanhSachUserTinDungComponent),
    canActivate: [authGuard]
  },
  {
    path: 'cong-no',
    loadComponent: () => import('./pages/cong-no/cong-no.component').then(m => m.CongNoComponent),
    canActivate: [authGuard]
  },
  {
    path: 'admin',
    loadComponent: () => import('./layouts/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: 'users',
        loadComponent: () => import('./pages/admin/users/users.component').then(m => m.UsersComponent)
      },
      {
        path: 'roles',
        loadComponent: () => import('./pages/admin/roles/roles.component').then(m => m.RolesComponent)
      },
      {
        path: 'roles/:roleId',
        loadComponent: () => import('./pages/admin/roles/role-detail/role-detail.component').then(m => m.RoleDetailComponent)
      },
      {
        path: 'permissions',
        loadComponent: () => import('./pages/admin/permissions/permissions.component').then(m => m.PermissionsComponent)
      },
      {
        path: 'permission-matrix',
        loadComponent: () => import('./pages/admin/permission-matrix/permission-matrix.component').then(m => m.PermissionMatrixComponent)
      },
      {
        path: 'organizations',
        loadComponent: () => import('./pages/admin/organizations/organizations.component').then(m => m.OrganizationsComponent)
      },
      {
        path: 'organizations/:idOrg',
        loadComponent: () => import('./pages/admin/organizations/organization-detail/organization-detail.component').then(m => m.OrganizationDetailComponent)
      },
      {
        path: 'organizations/:idOrg/:subOrgId',
        loadComponent: () => import('./pages/admin/organizations/sub-organization-detail/sub-organization-detail.component').then(m => m.SubOrganizationDetailComponent)
      },
      {
        path: '',
        redirectTo: 'users',
        pathMatch: 'full'
      }
    ]
  }
];
